$(function() {
    "use strict";

    if (
        $('.profile-header__menu').length > 0 &&
        $(window).scrollTop() == 0 &&
        !$('.profile-header__menu .tabbed-menu__active').is(':first-child')
    ) {
        $(window).scrollTop($('.profile-header__menu .tabbed-menu__element').offset().top - $('.header__mobile').height());
    }

    // Cards

    $(document).on('ready', function() {
        var $cards = $('.profile__cards');

        if ($cards.length > 0) {
            var $loadMore = $cards.find('.profile__load-more-cards'),
                $masonry  = $cards.find('.grid_masonry');

            $loadMore.off('.Grid').on('click', function(event) {
                event.preventDefault();

                var photoIds = [];
                var videoIds = [];
                $cards.find('.grid__cell [data-id]').each(function() {
                    if ($(this).data('type') == 'video') {
                        videoIds.push($(this).data('id'));
                    } else {
                        photoIds.push($(this).data('id'));
                    }
                });

                $masonry.trigger('Grid::loadMore', [{photo_ids: photoIds, video_ids: videoIds}]);

                if ('undefined' !== typeof window.Tracker) {
                    window.Tracker.pushEvent(
                        {
                            category: "Firm profile",
                            action: "Click on show more in portfolio"
                        }
                    );
                    window.Tracker.pushPageView(location.pathname + location.search + '#portfolio');
                }
             });
        }

        var $writeToFirmForm = $('.write-to-firm-form');

        if ($writeToFirmForm.length) {
            $writeToFirmForm.on('submit', function(e) {
                e.preventDefault();
                var $form = $(this);

                var $globalErrorField = $form.find('.error_global');
                var $errorFields = $form.find('.error');

                $.ajax(
                    {
                        url      : $form.attr('action'),
                        data     : $form.serialize(),
                        method   : 'post',
                        dataType : 'json'
                    }
                )
                    .done(
                    function(data) {
                        if (data && data.redirect) {
                            document.location = data.redirect;
                        } else {
                            $('.write-to-firm-form__success').show();
                        }
                    }
                )
                    .fail(
                    function(xhr) {
                        if (typeof(xhr.responseJSON) != 'undefined' && typeof(xhr.responseJSON.error) != 'undefined') {
                            if (xhr.responseJSON.error == 'user_already_exists') {
                                var value = $form.find('[name*="email"]').val();
                                var $screen = $('.i-screen_auth-email-exists');
                                $screen.find('.i-user-email').each(function() {
                                    var $this = $(this);

                                    if ($this.is('input')) {
                                        $this.val(value);
                                        $this.closest('form').trigger('validate-client');
                                    }
                                    else {
                                        $this.text(value);
                                    }
                                });
                                $('.b-enter').trigger('openScreen', ['auth-email-exists']);
                            } else {
                                $globalErrorField.html(xhr.responseJSON.error);
                            }
                        }
                        else if (typeof(xhr.responseJSON) != 'undefined' && typeof(xhr.responseJSON.errors) != 'undefined') {
                            for (var fieldName in xhr.responseJSON.errors) {
                                var $errorField = $errorFields.filter('[data-field="' + fieldName + '"]');
                                if ($errorField.length) {
                                    $errorField.html(xhr.responseJSON.errors[fieldName]);
                                } else {
                                    $globalErrorField.html('Произошла ошибка, попробуйте сохранить заново.');
                                }
                            }
                        }
                        else {
                            $globalErrorField.html('Произошла ошибка, попробуйте сохранить заново.');
                        }
                    }
                );

            });
        }

        if ('#send_to_vendor_success' === location.hash) {
            $('.write-to-firm-form__success').show();
        }
    });

    $('.profile-header:not(.profile-header_panel)').each(function () {
        var $document = $(document);
        var $profileHeader = $(this);
        var $profilePanel = $('.profile-header_panel');
        var $contactFirmPanel = $('.profile__contact-firm');
        var profilePanelShownClassName = 'profile-header_panel-shown';
        var contactFirmPanelShownClassName = 'profile__contact-firm_shown';

        var defineShowPanelsScrollTop = function () {
            var profileHeaderHeight = $profileHeader.outerHeight();
            var profileHeaderOffset = $profileHeader.offset().top;
            return profileHeaderOffset + profileHeaderHeight;
        };

        var showPanelsScrollTop = defineShowPanelsScrollTop();

        $(window).on('load resize', function () {
            showPanelsScrollTop = defineShowPanelsScrollTop();
        });

        $(window).on('scroll', function () {
            if ($document.scrollTop() >= showPanelsScrollTop) {
                $profilePanel.addClass(profilePanelShownClassName);
                $contactFirmPanel.addClass(contactFirmPanelShownClassName);
            }
            else {
                $profilePanel.removeClass(profilePanelShownClassName);
                $contactFirmPanel.removeClass(contactFirmPanelShownClassName);
            }
        });

        $document.on('ready', function () {
            $('.header_keep-static').removeClass('header_keep-static');
            $('.footer').addClass('footer_space-for-contact');
        });
    });

    // Tooltip
    var $tooltipHandle = $('[data-tooltip-handle]')
    var $tooltip = $('[data-tooltip]')

    $tooltipHandle.on('click', function (e) {
        e.stopPropagation()
        $tooltip.toggleClass('new-profile__tooltip_visible')
    })

    $(document).on('click', function () {
        $tooltip.removeClass('new-profile__tooltip_visible')
    })

    // Show hidden mobile user info
    var $userInfo = $('[data-user-info]')
    var $userInfoHandle = $('[data-user-info-handle]')

    $userInfoHandle.on('click', function () {
        $userInfo.addClass('new-profile__hidden-info_visible')
        $userInfoHandle.css('display', 'none')
    })
})
